require('./criticalResources');

import { initDependencies, setupDependencies } from './app';

setupDependencies();

initDependencies();

const { runApp } = require('./services/runApp');
runApp();

// tslint:disable-next-line: no-any
if ((module as any).hot) {
  // tslint:disable-next-line: no-any
  (module as any).hot.accept();
}
